import { cn } from '../../lib/_utils/cn';
import { VariantProps, cva } from 'class-variance-authority';

export const spinner = cva(['rounded-full border-[2px] !border-b-transparent animate-spin'], {
	variants: {
		variant: {
			primary: ['border-dark-950'],
			secondary: ['border-dark-950'],
			tertiary: ['border-white-500'],
			success: ['border-dark-500'],
			danger: ['border-dark-950'],
			warning: ['border-dark-500'],
			white: ['border-white'],
		},
		size: {
			sm: ['w-[14px] h-[14px] border-[2px]'],
			md: ['w-[16px] h-[16px]'],
			lg: ['w-[18px] h-[18px]'],
			xl: ['w-[20px] h-[20px]'],
			40: ['w-[40px] h-[40px]'],
			60: ['w-[60px] h-[60px]'],
			80: ['w-[80px] h-[80px]'],
		},
		outline: {
			true: [],
			false: [],
		},
		disabled: {
			true: [],
			false: [],
		},
	},
	compoundVariants: [
		{
			variant: 'primary',
			outline: true,
			className: ['border-primary-500'],
		},
		{
			variant: 'secondary',
			outline: true,
			className: ['border-secondary-500'],
		},
		{
			variant: 'tertiary',
			outline: true,
			className: ['border-white-500'],
		},
		{
			variant: 'success',
			outline: true,
			className: ['border-success-500'],
		},
		{
			variant: 'danger',
			outline: true,
			className: ['border-danger-500'],
		},
		{
			variant: 'warning',
			outline: true,
			className: ['border-warning-500'],
		},
	],
	defaultVariants: {
		variant: 'primary',
		size: 'lg',
		outline: false,
		disabled: false,
	},
});

export type SpinnerProps = VariantProps<typeof spinner> & {
	absolute?: boolean;
};

const Spinner = ({ variant, size, outline, disabled, absolute = true }: SpinnerProps) => (
	<div
		className={`${absolute ? 'absolute right-0 top-0 ' : 'relative'} flex h-full w-full items-center justify-center`}>
		<div className={`${cn(spinner({ variant, size, outline, disabled }))}`} />
	</div>
);

export default Spinner;
